import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, Clock } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60; // 15 minutos
const MAX_CUPOS = 20;
const START_CUPOS = 12;
const MIN_CUPOS = 6;
export function UrgencyBanner() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  const [cupos, setCupos] = useState(START_CUPOS);
  // Countdown timer
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  // Slowly decreasing cupos for live urgency (floors at MIN_CUPOS)
  useEffect(() => {
    const id = setInterval(() => {
      setCupos(c => c > MIN_CUPOS ? c - 1 : c);
    }, 28000);
    return () => clearInterval(id);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const progress = cupos / MAX_CUPOS * 100;
  return <motion.div animate={{
    boxShadow: ['0 0 22px rgba(220,38,38,0.25)', '0 0 36px rgba(220,38,38,0.5)', '0 0 22px rgba(220,38,38,0.25)']
  }} transition={{
    duration: 1.6,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className="mx-auto mb-6 max-w-[620px] overflow-hidden rounded-xl border border-red-500/60 bg-[linear-gradient(135deg,#2a0707,#170303)]" data-id="element-276">
      <div className="flex items-center gap-3 px-4 py-3 sm:gap-4 sm:px-5 sm:py-4" data-id="element-277">
        {/* Pulsing flame */}
        <motion.div animate={{
        scale: [1, 1.14, 1]
      }} transition={{
        duration: 1.3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-600 sm:h-10 sm:w-10" data-id="element-278">
          <Flame className="h-4 w-4 text-white sm:h-5 sm:w-5" strokeWidth={2.25} data-id="element-279" />
        </motion.div>

        {/* Message */}
        <div className="min-w-0 flex-1" data-id="element-280">
          <div className="text-[12px] font-extrabold uppercase tracking-[0.08em] text-red-400 sm:text-[13px]" data-id="element-281">
            ¡Últimos cupos en oferta!
          </div>
          <div className="text-[11px] leading-tight text-text sm:text-[12px]" data-id="element-282">
            Cuando se agoten, el precio sube{' '}
            <strong className="font-bold text-white" data-id="element-283">$10.000</strong> y no
            vuelve a bajar.
          </div>
        </div>

        {/* Countdown */}
        <motion.div animate={{
        opacity: [1, 0.55, 1]
      }} transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="flex shrink-0 items-center gap-1.5 rounded-lg bg-black/40 px-2.5 py-1.5 ring-1 ring-red-500/40" data-id="element-284">
          <Clock className="h-3.5 w-3.5 text-red-400 sm:h-4 sm:w-4" data-id="element-285" />
          <span className="font-serif text-[18px] font-black tabular-nums leading-none text-red-400 sm:text-[22px]" data-id="element-286">
            {pad(minutes)}:{pad(seconds)}
          </span>
        </motion.div>
      </div>

      {/* Cupos label + depleting slots bar */}
      <div className="px-4 pb-3 sm:px-5" data-id="element-287">
        <div className="mb-1.5 flex items-center justify-between text-[10px] font-bold uppercase tracking-[0.08em] sm:text-[11px]" data-id="element-288">
          <span className="text-red-400" data-id="element-289">
            🔥 Solo {cupos} cupos disponibles
          </span>
          <span className="text-muted" data-id="element-290">a este precio</span>
        </div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-black/50" data-id="element-291">
          <motion.div className="h-full rounded-full bg-gradient-to-r from-red-700 via-red-500 to-red-400" animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-292" />
        </div>
      </div>
    </motion.div>;
}